import { render, staticRenderFns } from "./QuestionCircle.vue?vue&type=template&id=9f0f98ae&"
import script from "./QuestionCircle.vue?vue&type=script&lang=ts&"
export * from "./QuestionCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports